




import { Component, Vue } from 'vue-property-decorator';
import NewRemoteDataTable, {
  RemoteDataField
} from '@/components/NewRemoteDataTable.vue';
import StoreSettingPin from '@/views/DashView/Stores/StoreSettingPin.vue';
import StoreAddEdit from '@/views/DashView/Stores/StoreAddEdit.vue';
import { getResponseToMTHForNewPort } from '@/utils/helpers';
import constants from '@/utils/constants';

class StoreItem {
  id: string = '';
  outletCode: string = '';
  name: string = '';
  address: string = '';
  phoneNumber: string = '';
  taxPercentage: number = 0.0;
  deliveryCharge: number = 0.0;
  areaCode: string = '';
  areaName: string = '';
  cityCode: string = '';
  cityName: string = '';
  isActive: string = '';
  latitude: number = 0.0;
  longitude: number = 0.0;
  isOpen24Hours: string = '';
}

@Component({
  components: {
    editor: StoreAddEdit,
    settingEditor: StoreSettingPin,
  }
})
class StoreList extends NewRemoteDataTable<StoreItem> {
  public pageTitle: string = 'Outlet List';
  public newButtonText: string = 'New Outlet';

  public fieldsSet: Array<RemoteDataField> = [
    new RemoteDataField({ key: 'index', label: '', sortable: false }),
    new RemoteDataField({ key: 'action', label: '', sortable: false }),
    new RemoteDataField({ key: 'outlet_code', label: 'Outlet Code' }),
    new RemoteDataField({ key: 'name', label: 'Name' }),
    new RemoteDataField({ key: 'address', label: 'Address' }),
    new RemoteDataField({ key: 'phone_number', label: 'PhoneNumber' }),
    new RemoteDataField({
      key: 'tax_percentage',
      label: 'Tax Percentage',
      formatter: 'formatterForPercent'
    }),
    new RemoteDataField({ key: 'area_code', label: 'Area Code' }),
    new RemoteDataField({ key: 'area_name', label: 'Area Name' }),
    new RemoteDataField({ key: 'city_code', label: 'City Code' }),
    new RemoteDataField({ key: 'city_name', label: 'City Name' }),
    new RemoteDataField({ key: 'is_active', label: 'Activity' }),
    new RemoteDataField({ key: 'latitude', label: 'Latitude' }),
    new RemoteDataField({ key: 'longitude', label: 'Longitude' }),
    new RemoteDataField({ key: 'is_open24_hours', label: '24 Hours Opening' })
  ];
  public uid: any = localStorage.getItem('UID');
  $swal: any;

  // to get page data
  get items(): StoreItem[] {
    return this.$store.getters.GetAllStoreForNewPort;
  }

  get paging(): StoreItem[] {
    return this.$store.getters.PagingStore;
  }

  get sorting(): StoreItem[] {
    return this.$store.getters.SortingStore;
  }

  get filtering(): StoreItem[] {
    return this.$store.getters.FilteringStore;
  }

  formatterForPercent(value) {
    return value ? `${value}%` : '-';
  }

  sortingChanged(ctx) {
    this.$store.dispatch('UpdateSortingStore', {
      byField: ctx.sortBy,
      isDesc: ctx.sortDesc,
      uid: this.uid
    });
  }

  filterChanged(isResetFilter) {
    this.$store.dispatch('UpdateFilteringStore', {
      isResetFilter: isResetFilter,
      uid: this.uid
    });
  }

  checkUserAndGetData() {
    this.$store.dispatch('GetAllStoreForNewPort', this.uid);
  }

  reload(id = null) {
    if (id === 1) {
      this.$store.state.store.pagingStore.page = 1;
    }
    this.checkUserAndGetData();
  }

  setPerPage(page) {
    this.$store.state.store.pagingStore.size = page;
    this.checkUserAndGetData();
  }

  // delete item
  deleteItem(item) {
    this.$swal({
      title: constants.ARE_YOU_SURE,
      text: constants.CONFIRM_DELETE_ITEM,
      icon: constants.STATUS_WARNING,
      buttons: true,
      dangerMode: true
    }).then(willDelete => {
      if (willDelete) {
        this.$store
          .dispatch('DeleteStoreForNewPort', item.id)
          .then(response => {
            getResponseToMTHForNewPort(
              response,
              this.$swal,
              constants.RECORD_IS_DELETED
            );
          })
          .catch(error => {
            this.$swal(
              constants.SOMETHING_WROING,
              error,
              constants.STATUS_ERROR
            );
          });
      }
    });
  }
}
@Component({
  components: {
    StoreList
  }
})
export default class Store extends Vue {}
